import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-crud-sidebar',
  templateUrl: './crud-sidebar.component.html',
  styleUrls: ['./crud-sidebar.component.scss'],
  standalone: false,
})
export class CrudSidebarComponent implements OnInit {
  @Output() itemSelected = new EventEmitter<string>();
  sidebarItems: string[] = [];
  selectedItem: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    this.getSelectedItemByUrlId();
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.sidebarItems = data['sidebarItems'] || [];
    });
    this.getSelectedItemByUrlId();
  }

  selectItem(item: string, index: number) {
    this.selectedItem = item;
    this.itemSelected.emit(item);
    this.goToCrud(index);
  }

  goToCrud(id: number) {
    this.location.replaceState('/dashboard');
    this.router.navigate(['/settings/crud', id]);
  }

  getSelectedItemByUrlId() {
    const id = +this.route.snapshot.paramMap.get('id')!;
    switch (id) {
      case 0: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION';
        break;
      }
      case 1: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER';
        break;
      }
      case 2: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION';
        break;
      }
      case 3: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER';
        break;
      }
      case 4: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER';
        break;
      }
      case 5: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE';
        break;
      }
      case 6: {
        this.selectedItem = 'COMMON.UT.SINGLE';
        break;
      }
      case 7: {
        this.selectedItem = 'COMMON.BU.SINGLE';
        break;
      }
      case 8: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.TARIFF';
        break;
      }
      case 9: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.METER_TYPE';
        break;
      }
      case 10: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.ASSET_RATING';
        break;
      }
      case 11: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.ASSET_STATUS';
        break;
      }
      case 12: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS';
        break;
      }
      case 13: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.DT_METER_TYPE';
        break;
      }
      case 14: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.SLT_STATUS';
        break;
      }
      case 15: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.METER_PRICE';
        break;
      }
      case 16: {
        this.selectedItem = 'CRUD_SETTINGS.CATEGORIES.BILLING_ACCOUNTS';
        break;
      }
    }
  }
}
